import './Projects.css';
import PropTypes from 'prop-types';
import zenerate_pdf from '../assets/IMPROVED_FLOORPLAN.pdf'


const MediaSlot = ({ youtubeId, imgSrc, pdfSrc, imgAlt, caption }) => (
  <figure className="media">
    {youtubeId ? (
      <div className="video-wrapper">
        <iframe
          src={`https://www.youtube.com/embed/${youtubeId}`}
          title="Demo video"
          loading="lazy"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        />
      </div>
    ) : pdfSrc ? (
      <div className="pdf-wrapper">
        <div className="pdf-scroll">
            <iframe
            src={pdfSrc}
            title="Embedded PDF"
            loading="lazy"
            />
        </div>
      </div>
    ) : (
      imgSrc && <img src={imgSrc} alt={imgAlt || ''} loading="lazy" />
    )}
    {caption && <figcaption className="project-caption">{caption}</figcaption>}
  </figure>
);

MediaSlot.propTypes = {
  youtubeId: PropTypes.string,
  imgSrc: PropTypes.string,
  imgAlt: PropTypes.string,
  caption: PropTypes.string,
};

const Section = ({ title, children }) => (
  <article className="project-section">
    <h3>{title}</h3>
    {children}
  </article>
);

Section.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
};


const Zenerate = () => {
    return(
        <section class="container grid project-contents">
            <br></br>
            <div class="project-contents">
                <h3> Zenerate — Floor Planning Optimization for Tower-Type Residential Buildings </h3>
                <br></br>
                <div class="project-text"> 
                    Collaborated with software engineers at Zenerate, a startup focused on design automation in architecture. <br></br>
                    The project aimed to enhance the floor planning logic for corridor and unit layouts in tower-type <br></br>
                    residential buildings. Using the team’s custom geometry kernel, I developed and integrated new features to <br></br>
                    efficiently handle tower configurations.The optimized algorithm improved plan efficiency by 4–5% per floor, 
                    resulting in additional usable floor area within the same building envelope.<br></br>
                </div>
            </div>

            <br></br>
            <div class="project-contents">
                <h3> Result Report </h3>
                <br></br>
                <MediaSlot
                    pdfSrc={zenerate_pdf}
                    // imgAlt="Tool query and discovery"
                />
                <p class="project-caption"> Report PDF </p>
                <div class="project-text"> 
                    This report was shared with the Zenerate team at the conclusion of the collaboration. It documents the full<br></br>
                    scope of the work ranging from analysis on the current condition — from the analysis of the existing algorithm and proposed <br></br>
                    pseudocode improvements to the results obtained from testing. <br></br>
                </div>
            </div>
        </section>
    );
}


export default Zenerate;